import type {
  DateTimeType,
  DateTimeValue
} from '@elfsight/configurator-contracts';

export function getDateByDateTimeValue(
  value: DateTimeValue<DateTimeType> | undefined,
  timeZone?: string
): Date {
  const day = new Date(new Date().toLocaleString('en', { timeZone }));

  if (!value) {
    return day;
  }

  const time =
    value.type !== 'date' ? value.time.split(':').map(Number) : [0, 0];

  if (value.type !== 'date' && (isNaN(time[0]) || isNaN(time[1]))) {
    // if the time is incorrect, use the current time
    const now = new Date();
    time[0] = now.getHours();
    time[1] = now.getMinutes();
  }

  if (value.type !== 'time') {
    const date = value.date.split('-');
    const year = parseInt(date[0], 10);
    const month = parseInt(date[1], 10);
    const dayPart = parseInt(date[2].split('T')[0], 10);

    if (isNaN(year) || isNaN(month) || isNaN(dayPart)) {
      // if the date is incorrect, use the current date
      const now = new Date();
      day.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
    } else {
      day.setFullYear(year, month - 1, dayPart);
    }
  }

  day.setHours(time[0], time[1], 0, 0);

  return day;
}
